/*eslint-disable*/
import { useEffect, useState } from 'react';

const VoiceOverlay = ({ recording, isPlaying, stopAudio }) => {
  const [shouldRender, setShouldRender] = useState(false);
  const [animationState, setAnimationState] = useState('hidden');

  useEffect(() => {
    if (isPlaying) {
      setShouldRender(true);
      requestAnimationFrame(() => setAnimationState('visible'));
    } else {
      setAnimationState('hidden');
      const timeout = setTimeout(() => setShouldRender(false), 1000);
      return () => clearTimeout(timeout);
    }
  }, [recording, isPlaying]);

  if (!shouldRender) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10,
        opacity: animationState === 'visible' ? 1 : 0,
        transformOrigin: 'center',
        transform:
          animationState === 'visible' ? 'translate(-50%, -50%) scale(1)' : 'translate(-50%, -50%) scale(0.95)',
        transition: 'opacity 0.4s ease, transform 0.4s ease',
      }}
    >
      <div
        style={{
          width: '140px',
          height: '140px',
          borderRadius: '50%',
          backgroundColor: '#e0f7fa',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0 0 12px rgba(0, 150, 255, 0.2)',
        }}
      >
        <img
          src={require('../../static/img/animation/voicewave.gif')}
          alt="Voice activity"
          style={{ width: '85%', borderRadius: '50%' }}
        />
      </div>
      {/* {isPlaying && (
        <button
          onClick={stopAudio}
          style={{
            position: 'absolute',
            bottom: '-50px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '5px 10px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Stop
        </button>
      )} */}
    </div>
  );
};

export default VoiceOverlay;
